import React, { Component } from "react";
import { Select, Spin, message, Radio, Space } from "antd";
import Bridge from "../../../utils/Bridge";
import dayjs from "dayjs";
import moment from "moment";
import { speech_demographics_form_type } from "../../../utils/consts";

const { Option } = Select;

export default class HandnessSmokingHistoryForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,

      dominant_hand:"",
      smoking_history: "",
      have_you_quit_smoking_in_the_past_year:"",
      email:"",
      neurostamp_id:"",
      modality_id:"",
      field_data:[]
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  
  get_demographic_details = () => {
    this.setState({loading:true})
    let params = "?participants_accounts_id=" + localStorage.getItem("ap_participants_accounts_id")+'&type='+speech_demographics_form_type.handness_and_smoking_history;
    Bridge.demographics.speech
      .get(params)
      .then((response) => {
        if (response.status == "1") {
          this.setState({
            field_data: response.field_data.handness_and_smoking_history,
            email:response.email,
            neurostamp_id:response.neurostamp_id,
            modality_id:response.modality_id,
          })
          for(let item of response.data){
            if(item.field=='DEMOG6'){
              this.setState({
                dominant_hand:item.value
              })
            }
            if(item.field=='DEMOG7'){
              this.setState({
                smoking_history:item.value
              })
            }
            if(item.field=='DEMOG71'){
              this.setState({
                have_you_quit_smoking_in_the_past_year:item.value
              })
            }
          }
          this.setState({loading:false})
        }else{
          this.setState({loading:false})
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  onChange = (date, dateString) => {
    this.setState({
      date_of_birth: date,
    });
  };
  validateName = (field, label) => {
    // Check if the input contains only alphabetic characters
    // if (!/^[A-Za-z]+$/.test(field)) {
    //   // message.warning(`${label} can only contain alphabetic characters.`);
    //   return `${label} can only contain alphabetic characters.`;
    // }
    // Check if the length of the input is within a specific range
    if (field.length <= 2 || field.length > 30) {
      // message.warning(`${label} must be between 2 and 30 characters long.`);
      return `${label} must be between 2 and 30 characters long.`;
    }
    return 1;
  };
  // step 1
  save_details = () => {
    if (!this.state.dominant_hand) {
      message.warning("Dominant hand is required");
      return;
    }
    if (!this.state.smoking_history) {
      message.warning("Smoking history is required");
      return;
    }
    if (this.state.smoking_history == 3) {
      if (!this.state.have_you_quit_smoking_in_the_past_year) {
        message.warning("Please select the value of 'Have you quit smoking in the past year?' field.");
        return;
      }
    }
    let field_data=this.state.field_data
    const uniqueNames = [...new Map(field_data.map(item => [item.field, item])).values()];
    let questions=[]
    for(let item of uniqueNames){
      if(item.field=='DEMOG6'){
        let obj={
          value:this.state.dominant_hand,
          view_name:item.view_name,
          form:"Handedness and Smoking History",
          field: item.field
        }
        questions.push(obj) 
      }
      if(item.field=='DEMOG7'){
        let obj={
          value:this.state.smoking_history,
          view_name:item.view_name,
          form:"Handedness and Smoking History",
          field: item.field
        }
        questions.push(obj) 
      }
      if(item.field=='DEMOG71'){
        let obj={
          value:this.state.have_you_quit_smoking_in_the_past_year,
          view_name:item.view_name,
          form:"Handedness and Smoking History",
          field: item.field
        }
        questions.push(obj) 
      }
    }  
    let params = {
      data: JSON.stringify(questions),
      step: speech_demographics_form_type.handness_and_smoking_history,
      action_type: this.props.is_update == true ? "update" : "insert",
      email:this.state.email,
      neurostamp_id:this.state.neurostamp_id,
      modality_id:this.state.modality_id,
    };
    this.setState({ loading: true });
    Bridge.demographics.speech
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                this.props.set_active_step(6);
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  onChangeDominantHand = (event) => {
    this.setState({ dominant_hand: event.target.value });
  };
  render() {
    const disabledDate = (current) => {
      // Disable all dates after today
      return current && current > moment().subtract(18, "years");
    };
    return (
      <div>
        <div className="header">
          <h3 className="text-uppercase">Handedness and Smoking History</h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
            <div className="form-group">
              <label className="input-heading">
                What is your dominant hand?{" "}
                <span className="text-danger">*</span>
              </label>
              <br />
              <Radio.Group
                onChange={this.onChangeDominantHand}
                value={this.state.dominant_hand}
                direction="vertical"
              >
                <Space direction="vertical">
                  <Radio value={"1"}>Right</Radio>
                  <Radio value={"2"}>Left</Radio>
                  <Radio value={"3"}>Ambidextrous</Radio>
                </Space>
              </Radio.Group>
            </div>
            <div className="form-group">
              <label className="mb-2 input-heading">
                Smoking History <span className="text-danger">*</span>
              </label>
              <br />
              <Select
                onChange={(value) =>
                  this.setState({
                    smoking_history: value,
                    have_you_quit_smoking_in_the_past_year: "",
                  })
                }
                value={this.state.smoking_history}
                style={{
                  width: "100%",
                  height: 55,
                  maxWidth: 500,
                }}
              >
                <Option value="">Select Smoking History</Option>
                <Option value="1">I currently smoke</Option>
                <Option value="2">I have never smoked</Option>
                <Option value="3">I previously smoked</Option>
              </Select>
              {this.state.smoking_history == "3" && (
                <div className="form-group mt-3">
                  <label className="input-heading">
                  Have you quit smoking in the past year?
                  </label>
                  <br />
                  <Radio.Group
                    onChange={(event) =>
                      this.setState({
                        have_you_quit_smoking_in_the_past_year:
                          event.target.value,
                      })
                    }
                    value={this.state.have_you_quit_smoking_in_the_past_year}
                    direction="vertical"
                  >
                    <Space direction="horizontal">
                      <Radio value={"1"}>Yes</Radio>
                      <Radio value={"2"}>No</Radio>
                    </Space>
                  </Radio.Group>
                </div>
              )}
            </div>
            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 0,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save_details()}
                >
                  Save{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                <button
                  style={{padding: "9px 28px 10px 21px"}}
                  onClick={() => this.props.set_active_step(4)}
                  className="submit-button"
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  Previous
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save_details()}
                >
                  Save & Next{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
